module.exports = __webpack_public_path__ + "static/media/class teacher.e3268179.svg";